/* global sessionStorage */
import decode from 'jwt-decode'

import { getAuthToken } from './auth'

export const CURRENT_USER_ID = 'CURRENT_USER_ID'

export function get () {
  let userId = sessionStorage.getItem(CURRENT_USER_ID)

  if (!userId) {
    const authToken = getAuthToken()
    try {
      userId = decode(authToken).user_id
    } catch (e) {
      userId = null
    }
  }

  return userId
}

export function set (userId) {
  sessionStorage.setItem(CURRENT_USER_ID, userId)
}

export function remove () {
  sessionStorage.removeItem(CURRENT_USER_ID)
}



// WEBPACK FOOTER //
// ./src/shared/utils/auth/currentUserId.js